__turbopack_context__.v({
  "column": "_7Hw-_W_column",
  "columnWrapper": "_7Hw-_W_columnWrapper",
});
